import * as Prismic from "@prismicio/client";
import LandingPageTemplate from "templates/LandingPageTemplate";
import DefaultTextPageTemplate from "templates/DefaultTextPageTemplate";
import { createClient } from "../prismic";
import PageNotFound from "./404";

const PrismicPage = ({ page }) => {
  const { type } = page;

  switch (type) {
    case "landingpage":
      return <LandingPageTemplate page={page} />;

    case "default_text_page":
      return <DefaultTextPageTemplate page={page} />;

    default:
      // ToDo: 404 page
      return <PageNotFound />;
  }
};

export async function getStaticPaths() {
  const client = createClient();
  const pages = await client.get({
    predicates: Prismic.predicate.any("document.type", [
      "landingpage",
      "default_text_page",
    ]),
    lang: "*",
    pageSize: 100,
  });

  return {
    paths: pages.results.map((doc) => ({ params: { uid: doc.uid } })),
    fallback: false,
  };
}

export async function getStaticProps({ params, previewData }) {
  const client = createClient({ previewData });
  const page = (
    await client.get({
      predicates: Prismic.predicate.any("document.type", [
        "landingpage",
        "default_text_page",
      ]),
      lang: "*",
      pageSize: 100,
    })
  )?.results.find((doc) => doc.uid === params.uid);

  return {
    props: {
      page,
    },
  };
}

export default PrismicPage;
